import React, { useCallback } from 'react';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import { useModalsContext } from 'UI/contexts/modals';
import { useT } from 'UI/lib';

const styles = theme => ({
  playButton: {
    alignSelf: 'center',
    cursor: 'pointer',
    height: 30,
    width: 30,
    marginLeft: 5,
  },
  playIcon: {
    fontSize: 30,
    color: theme?.palette?.componentColors?.h1TitleColor,
  },
});

const ExplainFeatureButton = ({ classes, params, deprecatedVideoUrl }) => {
  const modals = useModalsContext();
  const t = useT();
  const handlePlayExplainVideo = useCallback(
    () =>
      modals.open('EXPLAIN_VIDEO_BUTTON', {
        videoUrl: params && params.videoUrl,
        deprecatedVideoUrl,
      }),
    [modals, deprecatedVideoUrl, params]
  );

  return (
    <IconButton
      className={classes.playButton}
      onClick={handlePlayExplainVideo}
      aria-label={t('common:video_tutorial_title')}
    >
      <PlayCircleOutlineIcon className={classes.playIcon} />
    </IconButton>
  );
};

export default withStyles(styles)(ExplainFeatureButton);
